module.exports = __webpack_public_path__ + "static/z16-2-0002-ea2809982356809878d602f7bae35317.jpg";